import { render, staticRenderFns } from "./ProvisionHistory.vue?vue&type=template&id=7b6ed472&scoped=true&"
import script from "./ProvisionHistory.vue?vue&type=script&lang=js&"
export * from "./ProvisionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionHistory.vue?vue&type=style&index=0&id=7b6ed472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ed472",
  null
  
)

export default component.exports